import React, { useState } from 'react';
import nounarrows from '../../assets/images/noun_arrow_6402.png';
import cartfff from '../../assets/images/BF-Chart.png';


function Reporttitle() {
  

  return (
   <div className="reporttitle">
            <div className="reporttitle_l">
              <img src={cartfff} alt="arrows" />
              <h2>HQ DASHBOARD - PRODUCT ANALYSIS</h2>
            </div>
            <div className="reporttitle_r reporttitle_ranalysis">
              <a href="/hqreport">
                BILLING REPORT <img src={nounarrows} width="20" alt="arrow" />
              </a>
            </div>
          </div>
  );
}

export default Reporttitle;